import { ASSISTANT_ENABLED, BY_PART } from '../app/core/config/modularized.config';

const server = '//api.analytics.vcg-decoletaje.com/';

export const environment = {
  production: true,
  apiUrl: `${server}v1/`,
  imageUrl: `${server}image/`,
  downloadUrl: `${server}download/`,
  i18nFile: 'borneo',
  socketUrl: `${server}borneo-ws`,
  toasterTimeout: 15000,
  pageElements: 8,
  excelMaxSize: 32, // In MBs
  camMaxSize: 32, // In MBs
  androidAPK: `quanthum.apk`,
  camModularized: BY_PART,
  summaryModularized: BY_PART,
  manufacturingOrderModularized: BY_PART,
  schedulerDashboardModularized: BY_PART,
  schedulerChecklistModularized: BY_PART,
  schedulerConfigurationModularized: BY_PART,
  schedulerAutoControlModularized: BY_PART,
  schedulerSimulatorModularized: BY_PART,
  schedulerStatusModularized: BY_PART,
  modelGroupSectionInAdmin: BY_PART,
  menu: BY_PART,
  toolManagamentModularized: BY_PART,
  checkToolModularized: BY_PART,
  notificationsModularized: BY_PART,
  visualizatorModularized: BY_PART,
  maintenanceModularized: BY_PART,
  assistantModularized: ASSISTANT_ENABLED,
  schedulerInlineQuantityEdit: true,
  // Matrix of recipients automatically notified when piece quantity changes.
  // Full names are resolved via the existing /v1/user-roles/search endpoint at modal open.
  pieceQuantityNotificationRecipients: [
    'Eduardo Arrieta',
    'Alex Segura',
    'Carlos Riera',
    'DANI RIOSERAS',
  ] as string[],
  // Matrix of recipients automatically notified when delivery date changes.
  // Resolved via /v1/user-roles/search at modal open.
  deliveryDateNotificationRecipients: [
    'Carlos Riera',
    'Eduardo Arrieta',
    'Alex Segura',
    'Dennis Amo',
    'Ainhoa Martinez',
    'DANI RIOSERAS',
  ] as string[],
  // Matrix of recipients automatically notified when the raw material (MP) changes.
  // Resolved via /v1/user-roles/search at modal open.
  materialNotificationRecipients: [
    'Alex Segura',
    'Carlos Riera',
    'DANI RIOSERAS',
    'Eduardo Arrieta',
  ] as string[],
  // Matrix of recipients automatically notified when an OF is marked urgent
  // from the planner (long-press on the OF code). Resolved via /v1/users-roles/search.
  urgentNotificationRecipients: [
    'Carlos Riera',
    'Alex Segura',
    'Eduardo Arrieta',
    'Dennis Amo',
    'Ainhoa Martinez',
    'DANI RIOSERAS',
  ] as string[],
  // Matrix of recipients automatically notified when an OF is marked claimed
  // from the planner (long-press on the article number cell). Same 6 as urgent.
  claimedNotificationRecipients: [
    'Carlos Riera',
    'Alex Segura',
    'Eduardo Arrieta',
    'Dennis Amo',
    'Ainhoa Martinez',
    'DANI RIOSERAS',
  ] as string[],
};



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/environments/environment.ts